import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import { metaTag } from "../Library/commomLib";
import Preloader from "../Components/Common/Preloader";
const TitleComponent = React.lazy(() => import("../Components/RootComponents/TitleComponent"));
const TitlePage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <TitleComponent />
      </Suspense>
    </Fragment>
  );
};

export default TitlePage;
